import { getAvailableStorage } from './storage.mjs';

const STORE_KEY = '__coveo.analytics.history';
const MAX_NUMBER_OF_HISTORY_ELEMENTS = 20;
const MIN_THRESHOLD_FOR_DUPLICATE_VALUE = 1000 * 60;
const MAX_VALUE_SIZE = 75;
class HistoryStore {
    constructor(store) {
        this.store = store || getAvailableStorage();
    }
    addElement(elem) {
        elem.internalTime = new Date().getTime();
        elem = this.cropQueryElement(this.stripEmptyQuery(elem));
        let currentHistory = this.getHistoryWithInternalTime();
        if (currentHistory != null) {
            if (this.isValidEntry(elem)) {
                this.setHistory([elem].concat(currentHistory));
            }
        }
        else {
            this.setHistory([elem]);
        }
    }
    async addElementAsync(elem) {
        elem.internalTime = new Date().getTime();
        elem = this.cropQueryElement(this.stripEmptyQuery(elem));
        let currentHistory = await this.getHistoryWithInternalTimeAsync();
        if (currentHistory != null) {
            if (this.isValidEntry(elem)) {
                this.setHistory([elem].concat(currentHistory));
            }
        }
        else {
            this.setHistory([elem]);
        }
    }
    getHistory() {
        const history = this.getHistoryWithInternalTime();
        return this.stripEmptyQueries(this.stripInternalTime(history));
    }
    async getHistoryAsync() {
        const history = await this.getHistoryWithInternalTimeAsync();
        return this.stripEmptyQueries(this.stripInternalTime(history));
    }
    getHistoryWithInternalTime() {
        try {
            const elements = this.store.getItem(STORE_KEY);
            if (elements && typeof elements === 'string') {
                return JSON.parse(elements);
            }
            else {
                return [];
            }
        }
        catch (e) {
            return [];
        }
    }
    async getHistoryWithInternalTimeAsync() {
        try {
            const elements = await this.store.getItem(STORE_KEY);
            if (elements) {
                return JSON.parse(elements);
            }
            else {
                return [];
            }
        }
        catch (e) {
            return [];
        }
    }
    setHistory(history) {
        try {
            this.store.setItem(STORE_KEY, JSON.stringify(history.slice(0, MAX_NUMBER_OF_HISTORY_ELEMENTS)));
        }
        catch (e) {
        }
    }
    clear() {
        try {
            this.store.removeItem(STORE_KEY);
        }
        catch (e) {
        }
    }
    getMostRecentElement() {
        let currentHistory = this.getHistoryWithInternalTime();
        if (Array.isArray(currentHistory)) {
            const sorted = currentHistory.sort((first, second) => {
                return (second.internalTime || 0) - (first.internalTime || 0);
            });
            return sorted[0];
        }
        return null;
    }
    cropQueryElement(part) {
        if (part.name && part.value && part.name.toLowerCase() === 'query') {
            part.value = part.value.slice(0, MAX_VALUE_SIZE);
        }
        return part;
    }
    isValidEntry(elem) {
        let lastEntry = this.getMostRecentElement();
        if (lastEntry && lastEntry.value == elem.value) {
            return ((elem.internalTime || 0) - (lastEntry.internalTime || 0) > MIN_THRESHOLD_FOR_DUPLICATE_VALUE);
        }
        return true;
    }
    stripInternalTime(history) {
        if (Array.isArray(history)) {
            return history.map((part) => {
                const { name, time, value } = part;
                return { name, time, value };
            });
        }
        return [];
    }
    stripEmptyQuery(part) {
        const { name, time, value } = part;
        if (name &&
            typeof value === 'string' &&
            name.toLowerCase() === 'query' &&
            value.trim() === '') {
            return { name, time };
        }
        return part;
    }
    stripEmptyQueries(history) {
        return history.map((part) => this.stripEmptyQuery(part));
    }
}

export { HistoryStore, MAX_NUMBER_OF_HISTORY_ELEMENTS, MAX_VALUE_SIZE, MIN_THRESHOLD_FOR_DUPLICATE_VALUE, STORE_KEY, HistoryStore as default };
